import { useCallback } from "react";
import { useTheme } from "@/components/theme-provider";
import { track, LogEvents } from "@/analytics/track";

type Theme = "light" | "dark" | "system";

export function useChangeTheme() {
  const { theme, setTheme } = useTheme();

  const changeTheme = useCallback(
    (next: Theme) => {
      setTheme(next);
      track({
        event: LogEvents.ThemeChanged.name,
        channel: LogEvents.ThemeChanged.channel,
        theme: next,
      });
    },
    [setTheme],
  );

  return { theme, changeTheme };
}
